<template>
  <div id="app">
    <!-- Skip link for a11y -->
    <a class="skip" href="#main">Skip to content</a>

    <header class="nav">
      <div class="nav__inner">
        <router-link to="/" class="brand" aria-label="Home">
          <img src="./assets/logo.png" alt="" class="logo" />
          <span class="brand__name">PathTracer</span>
        </router-link>

        <!-- Mobile toggle -->
        <button
          class="hamburger"
          :aria-expanded="menuOpen ? 'true' : 'false'"
          aria-label="Toggle navigation"
          @click="menuOpen = !menuOpen"
        >
          <span></span><span></span><span></span>
        </button>
<!-- Add a scrim right after the hamburger -->
<div
  v-if="menuOpen"
  class="nav__scrim"
  @click="menuOpen = false"
  aria-hidden="true"
></div>
        <nav class="links" :class="{ open: menuOpen }" @click="handleNavClick">
          <ul>
            <li v-if="isAuthenticated"><router-link to="/analysistool" exact-active-class="active">Analyze</router-link></li>
            <li v-if="isAuthenticated"><router-link to="/about" exact-active-class="active">About</router-link></li>
            <li v-if="isAuthenticated"><router-link to="/BasicTutorial" exact-active-class="active">Guide</router-link></li>
          <!--  <li v-if="isAuthenticated"><router-link to="/support" exact-active-class="active">Support</router-link></li>-->

            <li v-if="isAuthenticated && isAdmin">
              <router-link to="/admin" exact-active-class="active">
                Admin Panel <span class="badge badge--admin">Admin</span>
              </router-link>
            </li>
            <li v-if="isAuthenticated && isAdminOrModerator">
              <router-link to="/moderator" exact-active-class="active">
                Mod Panel <span class="badge badge--mod">Mod</span>
              </router-link>
            </li>
            <li v-if="isAuthenticated && isAdmin">
              <router-link to="/BugReports" exact-active-class="active">Bug Reports</router-link>
            </li>
  <li v-if="!isAuthenticated && !$route.path.startsWith('/login')">
      <router-link to="/login" exact-active-class="active">Login</router-link>
    </li>
             <li v-if="isAuthenticated && !isAdmin"><router-link to="/account-page" exact-active-class="active">My Account</router-link></li>

            <li v-if="isAuthenticated">
              <button class="btn btn--ghost" @click="handleLogout">Logout</button>
            </li>
          </ul>
        </nav>
      </div>
    </header>
<AnnouncementBar v-if="announcement" :config="announcement" />

    <main id="main">
      <router-view @login-success="checkAuth"></router-view>
    </main>

    
    <AppFooter />
  </div>
</template>

<script>
  import AppFooter from '@/components/AppFooter.vue';

import AuthService from '@/services/AuthService';
import AnnouncementBar from '@/components/AnnouncementBar.vue';
import { resolveAnnouncement  } from '@/utils/announcements';
export default {
  name: 'App',
  components: { AnnouncementBar, AppFooter },
  data() {
    // const ANNOUNCE_SLUG = null; // <— change here when you want a different one
     const ANNOUNCE_SLUG = null; // <— change here when you want a different one
    //  const ANNOUNCE_SLUG = 'launchv2'; // <— change here when you want a different one
    
    return {
      isAuthenticated: false,
      isAdmin: false,
      isAdminOrModerator: false,
      menuOpen: false,
    // Only 'maintenance' may show a post-event ("completed") message.
     announcement: resolveAnnouncement(ANNOUNCE_SLUG, {
      allowAfterOnlyFor: ['maintenance']
        })
    };
  },
  created() {
    this.checkAuth();
  },
   mounted() {
    // Close on Esc
    this._esc = (e) => { if (e.key === 'Escape') this.menuOpen = false; };
    window.addEventListener('keydown', this._esc);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this._esc);
  },
  watch: {
    $route() { this.menuOpen = false; },
    menuOpen(v) { document.body.classList.toggle('nav-locked', v); }
  },
  methods: {
    handleNavClick(e) {
      const tag = e.target.closest('a,button');
      if (tag) this.menuOpen = false;
    },
    checkAuth() {
      AuthService.isAuthenticated().then(isAuthenticated => {
        this.isAuthenticated = isAuthenticated;
        if (isAuthenticated) {
          AuthService.getUserRole()
            .then(({ role }) => {
              this.isAdmin = (role === 'admin');
              this.isAdminOrModerator = (role === 'admin' || role === 'moderator');
            })
            .catch(() => {
              this.isAdmin = false;
              this.isAdminOrModerator = false;
            });
        }
      });
    },
    handleLogout() {
      AuthService.logout();
      this.isAuthenticated = false;
      this.isAdmin = false;
      this.isAdminOrModerator = false;
     // this.$router.push('/');
  this.$router.replace({ name: 'login' }); // or { path: '/login' }
    }
  }
};
</script>

<style>
/* ========== Base (unchanged) ========== */
#app { font-family: Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji"; color: #1f2a37; }
a { color: inherit; text-decoration: none; }
ul { list-style: none; margin: 0; padding: 0; }
button { font: inherit; }

/* Skip link */
.skip {
  position: absolute; left: -9999px; top: auto; width: 1px; height: 1px; overflow: hidden;
}
.skip:focus {
  position: fixed; left: 1rem; top: 1rem; width: auto; height: auto; padding: .5rem .75rem;
  background: #fff; color: #111; border-radius: 10px; box-shadow: 0 6px 16px rgba(0,0,0,.15);
  z-index: 2000;
}

/* ========== NAVY MODE ========== */
.nav {
  --nav-h: 64px;
  --nav-bg1: rgba(11, 27, 43, .96);   /* deep navy */
  --nav-bg2: rgba(15, 38, 61, .94);   /* darker navy */
  --nav-ac1: rgba(28, 95, 151, .28);  /* soft blue glow */
  --nav-ac2: rgba(10, 129, 184, .18); /* accent glow */
  --nav-border: rgba(255,255,255,.08);
  --ink: #eaf2ff;           /* primary link text */
  --ink-muted: #9fb3c8;     /* muted text */
  --ink-active: #ffffff;    /* active/hover text */

  position: sticky; top: 0; z-index: 1000;
  backdrop-filter: saturate(1.2) blur(10px);

  /* layered gradient for depth + subtle glows */
  background:
    radial-gradient(180px 120px at 85% 20%, var(--nav-ac2), transparent 60%),
    radial-gradient(220px 160px at 10% 90%, var(--nav-ac1), transparent 60%),
    linear-gradient(180deg, var(--nav-bg1), var(--nav-bg2));
  border-bottom: 1px solid var(--nav-border);
  box-shadow: 0 6px 18px rgba(0,0,0,.28);
}
.nav__inner {
  height: var(--nav-h);
  max-width: 1120px; margin: 0 auto;
  display: grid; grid-template-columns: auto 1fr; align-items: center; gap: .75rem;
  padding: 0 1rem;
}

/* Brand */
.brand { display: inline-flex; align-items: center; gap: .6rem; font-weight: 800; letter-spacing: .2px; }
.logo { height: 34px; width: auto; display: block; }
.brand__name { font-size: 1.05rem; color: var(--ink); }

/* Links */
.links { justify-self: end; }
.links ul { display: flex; align-items: center; gap: .85rem; }
.links a {
  padding: .5rem .6rem; border-radius: 9px;
  color: var(--ink); transition: background-color .15s ease, color .15s ease, border-color .15s ease;
  border: 1px solid transparent;
}
.links a:hover {
  background: rgba(255,255,255,.06);
  border-color: rgba(255,255,255,.08);
  color: var(--ink-active);
}
.links a.active {
  color: var(--ink-active);
  background: rgba(58,160,255,.18);
  border-color: rgba(58,160,255,.28);
  box-shadow: inset 0 0 0 1px rgba(58,160,255,.22);
}

/* Role badges */
.badge {
  display: inline-block; margin-left: .35rem; padding: .06rem .45rem;
  font-size: .72rem; border-radius: 999px; border: 1px solid rgba(255,255,255,.14);
  background: rgba(255,255,255,.08); color: var(--ink); font-weight: 700;
}
.badge--admin { background: rgba(255, 86, 86, .18); border-color: rgba(255,86,86,.28); }
.badge--mod   { background: rgba(86, 172, 255, .18); border-color: rgba(86,172,255,.28); }

/* Logout button styled to match links */
.btn {
  padding: .5rem .7rem; border-radius: 9px; border: 1px solid rgba(255,255,255,.12);
  background: rgba(255,255,255,.06); color: var(--ink);
  cursor: pointer; transition: background .15s ease, color .15s ease, border-color .15s ease;
}
.btn--ghost:hover { background: rgba(255,255,255,.1); border-color: rgba(255,255,255,.2); color: #fff; }
.btn:focus-visible { outline: 3px solid rgba(58,160,255,.4); outline-offset: 2px; }

/* Hamburger (mobile) */
.hamburger {
  display: none;
  width: 40px; height: 40px; border-radius: 10px;
  border: 1px solid rgba(255,255,255,.14); background: rgba(255,255,255,.06); cursor: pointer;
  align-items: center; justify-content: center; gap: 4px;
}
.hamburger span { display: block; width: 18px; height: 2px; background: #eaf2ff; }
.hamburger:hover { background: rgba(255,255,255,.1); }
.hamburger:focus-visible { outline: 3px solid rgba(58,160,255,.4); outline-offset: 2px; }
/* Prevent body scroll when drawer is open */
body.nav-locked { overflow: hidden; }

/* Scrim covers the page when the drawer is open */
.nav__scrim {
  position: fixed;
  inset: var(--nav-h) 0 0 0;     /* below the navbar */
  background: rgba(0,0,0,.45);
  z-index: 1199;
}

/* Mobile drawer lives above scrim and does NOT affect layout */
@media (max-width: 900px) {
  /* Right-align the hamburger in column 3 */
  .nav__inner {
    grid-template-columns: auto 1fr auto; /* brand | spacer | hamburger */
  }
    /* show the hamburger on mobile */
  .hamburger{
    display: inline-flex;          /* was none */
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 10px;
    border: 1px solid rgba(255,255,255,.18);
    background: rgba(255,255,255,.10);
    z-index: 1300;                 /* above scrim (1199) and drawer (1200 edge) */
    grid-column: 3;           /* force it to the right column */
    justify-self: end;        /* align to right edge of that column */
  }
  .hamburger span{ width: 18px; height: 2px; background: #eaf2ff; display:block; }
  .hamburger:hover{ background: rgba(255,255,255,.16); }
  .hamburger:focus-visible{ outline: 3px solid rgba(58,160,255,.4); outline-offset: 2px; }

  /* give it a dedicated column on the right so it never wraps */
  .nav__inner{
    grid-template-columns: auto 1fr auto; /* brand | spacer | hamburger */
  }


  .links {
    position: fixed;
    inset: var(--nav-h) 0 0 0;
    z-index: 1200;
    background: #f9fafb;                 /* light panel for black text */
    transform: translateY(-8px);
    opacity: 0;
    pointer-events: none;
    transition: opacity .18s ease, transform .18s ease;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
    border-top: 1px solid #e5e7eb;
    box-shadow: 0 12px 30px rgba(0,0,0,.35);
  }
  .links.open {
    transform: translateY(0);
    opacity: 1;
    pointer-events: auto;
  }

  /* Vertical button list */
  .links ul {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0;
    padding: .5rem 0;
  }
  .links li { border-bottom: 1px solid #e5e7eb; }

  .links a,
  .btn--ghost {
    display: block;
    padding: 1rem 1.2rem;
    border-radius: 0;
    background: linear-gradient(to right, #ffffff, #f3f4f6);
    color: #000 !important;              /* enforce legibility */
    font-size: 1rem;
    font-weight: 500;
    text-align: left;
    transition: background .15s ease;
  }
  .links a:hover,
  .btn--ghost:hover {
    background: linear-gradient(to right, #f9fafb, #e5e7eb);
  }
  .links a.active {
    background: linear-gradient(to right, #e0f2fe, #bae6fd);
    color: #000 !important;
    font-weight: 600;
  }

    /* Make the Logout button look like the other vertical nav items */
  .links li > button.btn {
    display: block;
    width: 100%;
    padding: 1rem 1.2rem;                      /* match link padding */
    border-radius: 0;
    text-align: left;
    background: linear-gradient(to right, #ffffff, #f3f4f6);
    color: #000 !important;
    font-size: 1rem;
    font-weight: 500;
  }
  .links li > button.btn:hover {
    background: linear-gradient(to right, #f9fafb, #e5e7eb);
  }
}



/* Main spacing */
main { padding: 1rem; }

/* Muted text (if you need it inside the nav) */
.nav .muted { color: var(--ink-muted); }


html, body { height: 100%; }
body { margin: 0; }

/* Make the app a vertical layout */
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  font-family: Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji";
  color: #1f2a37;
}

/* Main should grow and push footer down */
main {
  flex: 1 0 auto;
  padding: 1rem;
}

</style>
